/**
 * @note
 * for hook alternative of route element composition:
 * - https://reactrouter.com/docs/en/v6/upgrading/v5#use-useroutes-instead-of-react-router-config
 * - https://reactrouter.com/docs/en/v6/examples/route-objects
 *
 * might need to take notes on:
 * - https://reactrouter.com/docs/en/v6/upgrading/v5#note-on-link-to-values
 */

import { Suspense } from 'react';

import { Route, Routes } from 'react-router-dom';
import RequireAuth from '~/components/auth/RequireAuth';
import Layout from '~/components/layout/app-shell/Layout';
import NotFoundPage from '~/pages/404/NotFoundPage';
import SignInPage from '../pages/auth/SignInPage';
import SignUpPage from '../pages/auth/SignUpPage';
import { privateRoutes } from './routes';

const Routings = () => {
  return (
    <Suspense>
      <Routes>
        <Route path="/signin" element={<SignInPage />} key={'/signin'} />
        <Route path="/signup" element={<SignUpPage />} key={'/signup'} />

        {privateRoutes.map(({ element, bodyPadding, bgColor, ...privateRouteProps }) => (
          <Route
            element={
              <RequireAuth redirectTo={`/signin?redirectTo=${privateRouteProps.path}`}>
                <Layout>{element}</Layout>
              </RequireAuth>
            }
            {...privateRouteProps}
            key={`privateRoute-${privateRouteProps.path}`}
          />
        ))}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
};

export default Routings;
